import axios from 'axios';

import env, { ACCESS } from '../.env.js';

export default axios.create({
  baseURL: env({ access: ACCESS.API }),
});
